module.exports = __webpack_public_path__ + "static/Personal Growth-bg@3x-6c9409e4d697181167fde1f636ec341f.png";